import {formatoFecha} from "./formatoFecha";
import {formatoMoneda} from "../../Utilidades/formatoMoneda";
import {NUMEROATENCION} from "../../Constantes";

export const envioMensajeWass = (pedido) => {

    let string = pedidoToString(pedido)

    let stringURL = encodeURI(string)

    let link = `https://wa.me/57${NUMEROATENCION}?text=${stringURL}`
    window.open(link)

}

const pedidoToString = (ped) => {

    let text =
        `NUEVO PEDIDO NUM: ${ped.consecutivo}
        ${formatoFecha(ped.fecha)}       
         
        Nombre: ${sanificarTexto(ped.nombre)}
        Ciudad: ${sanificarTexto(ped.ciudad)}
        Direccion: ${sanificarTexto(ped.direccion)}
        Celular uno: ${sanificarTexto(ped.celular)}
        Celular dos: ${sanificarTexto(ped.otroCelular)}
        Indicaciones: ${sanificarTexto(ped.indicaciones)}       
        
        Productos:\n\n${obtenerProducutos(ped.productos)}
        
        Valor total de referencia: ${formatoMoneda(ped.valor)}
        `

    return text

}

const obtenerProducutos = (prods=[]) => {

    let text = ''
    for (let i = 0; i < prods.length; i++) {
        let producto = prods[i]
        text += `[${producto.cantidad} Und ${producto.presentacion}] ${producto.nombre}-${producto.marca} (${formatoMoneda(producto.cantidad * producto.valor)})\n`
    }

    return text
}

const sanificarTexto = (tex) => {

    if (!tex) {
        return ''
    }

    let res = tex.replaceAll('#', '-')

    return res
}